<template>
  <nav v-if="showNav && this.currentUserDashboard" class="app-nav">
    <v-container fluid>
      <v-toolbar
        density="compact"
        style="background-color: #ffffff"
        class="elevation-0 align-center"
        height="74"
    >
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="text-grey-darken-2 hidden-md-and-up"
      ></v-app-bar-nav-icon>
        <div class="d-flex align-center cursor-pointer">
          <div class="mt-1 mb-1 mr-2">
            <v-img
                lazy
                height="40"
                width="40"
                :src="require('../assets/logo.png')"
            ></v-img>
          </div>
          <div class="text-subtitle-1 ml-n1">
            <span class="font-weight-black teks-effect-toright hidden-sm-and-down">DPMD</span>
            <div
                class="text-subtitle-2 mt-n3 text-grey-darken-2 font-weight-light hidden-sm-and-down"
            >
              Kabupaten Bekasi
            </div>
          </div>
        </div>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="isActive('/statistik-dashboard')?'elevated':'plain'"
                :class="isActive('/statistik-dashboard')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                :to="{ path: '/statistik-dashboard' }"
                v-if="currentUserDashboard"
            >
              <span>Dashboard</span>
            </v-btn>
          </div>
        </v-toolbar-items>
        <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="isActive('/peta-interaktif')?'elevated':'plain'"
                :class="isActive('/peta-interaktif')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                :to="{ path: '/peta-interaktif' }"
                v-if="currentUserDashboard"
            >
              <span>Peta Interaktif</span>
            </v-btn>
          </div>
        </v-toolbar-items>
        <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="'plain'"
                :class="'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                @click="logOut"
                v-if="currentUserDashboard"
            >
              <span>Logout <v-icon>mdi-logout</v-icon> </span>
            </v-btn>
          </div>
        </v-toolbar-items>
      <v-toolbar-items>
        <div>
          <v-img
            lazy
            width="120"
            :src="require('@/assets/images/logo-menubar1.png')"
          ></v-img>
        </div>
      </v-toolbar-items>
    </v-toolbar>
    </v-container>
  </nav>
  <v-navigation-drawer
      v-model="drawer"
      v-if="showNav && isMobile"
      temporary
      location="left"
      :scrim="true"
      elevation="8"
      class="hidden-md-and-up mobile-drawer">
    <v-layout column>
      <div class="d-flex flex-row justify-center align-center mt-3 mb-2">
        <v-img
            lazy-src="../assets/logo.png"
            max-height="50"
            max-width="50"
            src="../assets/logo.png"
        ></v-img>
      </div>
      <div class="font-weight-light title ml-1">
        <span class="font-weight-black teks-effect-toright">DPMD</span>
        <div
            class="narrow-letter-spacing subtitle-2 mt-n3 text-grey text--darken-2 font-weight-regular"
        >
          Kabupaten Bekasi
        </div>
      </div>

    </v-layout>

    <v-divider></v-divider>
    <v-list>
      <v-list-item color="deep-orange" base-color="black" route to="/statistik-dashboard">
        <template #prepend>
          <v-icon>mdi-chart-arc</v-icon>
        </template>
        <v-list-item-subtitle>Dashboard</v-list-item-subtitle>
      </v-list-item>
      <v-list-item color="deep-orange" base-color="black" route to="/peta-interaktif">
        <template #prepend>
          <v-icon>mdi-map</v-icon>
        </template>
        <v-list-item-subtitle>Peta Interaktif</v-list-item-subtitle>
      </v-list-item>
      <v-list-item color="deep-orange" base-color="black" @click="logOut">
        <template #prepend>
          <v-icon>mdi-logout</v-icon>
        </template>
        <v-list-item-subtitle>Logout</v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { useDisplay } from "vuetify";
import FArticleCategService from "@/services/apiservices-elibrary/f-article-categ-service";
import CryptoJS from "crypto-js";
import EArticleCategGroup from "@/models/e-article-categ-group";
import ERole from "@/models/e-role";
export default {
  name: "NavBar",
  data() {
    return {
      drawer: false,
      isDarkMode: false,
      switchOn: false,
      mdAndUp: null,
      itemsGroup: [
        {id: 1, description: "Dokumen Perencanaan"},
      ],
      farticleCategs: [

      ]
    };
  },
  computed: {
    isMobile() {
      const v = this.mdAndUp;
      // mdAndUp is a Ref from Vuetify useDisplay; templates may not always unwrap it when stored in data.
      const mdUp = v && typeof v === 'object' && 'value' in v ? v.value : !!v;
      return !mdUp;
    },
    showNav() {
      const excludePaths = [
        "/login", "/register",
        "/registration-active",
        "/reset-success",

        "/reset-atur-ulang",
        "/reset-masukkan-otp",
        "/reset-masukkan-otp-password"
      ];

      const currentPath = this.$route.path;

      return !excludePaths.some((path) => currentPath.startsWith(path));
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserDashboard(){
      if(this.$store.state.auth.user){
        if(this.$store.state.auth.user.roles.includes(ERole.ROLE_USER)){
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    // routeToArsip(item) {
    //   // this.$router.push(
    //   //     "/public-event-webinar-detail/" + this.linkNeated(item.id.toString())
    //   // );
    //   this.$router.push(
    //       "/public-arsip/" + this.encryptText(item.farticleCategBean.toString())
    //   );
    //
    // },
    encryptText(teks) {
      const  secretKey = 'DESGREEN#1'
      const ciphertext = CryptoJS.AES.encrypt(teks, secretKey).toString();
      return ciphertext.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    },
    fetchArticleCateg(){
      FArticleCategService.getAllFArticleCategPublic().then(
          (response) => {
            this.farticleCategs = response.data.filter((x) => x.statusActive === true && x.articleCategGroup === EArticleCategGroup.DATA_PERENCANAAN)
          }
      )
    },
    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },
    isActive(path) {
      return this.$route.path === path;
    },
    routeToPage(path){
      if(path !== ""){
        this.$router.push(path)
      }
    }
  },
  mounted() {
    this.fetchArticleCateg()
  },
  created() {
    // Gunakan useDisplay untuk mendapatkan status breakpoint
    const { mdAndUp } = useDisplay();
    this.mdAndUp = mdAndUp;
  },
};
</script>



<style scoped>
.app-nav{

  height: 82px;      /* sesuaikan */
  display: flex;
  align-items: center;

  background: rgba(255,255,255);
  box-shadow: 0 2px 4px rgba(0,0,0,0.12);
  backdrop-filter: blur(10px);

  transition: background-color 220ms ease, box-shadow 220ms ease, backdrop-filter 220ms ease, transform 220ms ease;
}
.color-bg-primary {
  background-color: #FF8030;
}
.color-bg-grey {
  background-color: #2C3137 !important;
}
.color-text-primary {
  color: #FF8030;
}
.color-text-second {
  color: #002647;
}
.teks-effect-toright {
  font-size: 0px;
  font-weight: bolder;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-align: center;

  background: linear-gradient(to right, #3f51b5, #2196f3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradient 5s ease infinite;

  text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #231557 0%,
    #44107a 29%,
    #ff1361 67%,
    #fff800 100%
  );

  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
  font-size: 22px;
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}

.waviy {
  position: relative;
  font-weight: bolder;
}
.waviy span {
  position: relative;
  display: inline-block;
  font-size: 40px;
  color: #0f2270;
  text-transform: uppercase;
  animation: flip 2s infinite;
  animation-delay: calc(0.2s * var(--i));
}
@keyframes flip {
  0%,
  80% {
    transform: rotateY(360deg);
  }
}

.custom-btn {
  transition: all 0.5s ease; /* Menambahkan transisi halus */
  color: #000000; /* Warna teks */
  background-color: #ffffff; /* Warna latar belakang */
  border-radius: 1px; /* Sudut tombol */
  letter-spacing: 0px;
}

.custom-btn:hover {
  transition: all 0.5s ease; /* Menambahkan transisi halus */
  color: white;
  background-color: #FF8030; /* Warna latar belakang tipis saat hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Bayangan saat dihover */
}
.hover-list:hover .v-list-item-title {
  color: #FF8030 !important;
}
.hover-list:hover{
  background-color: #41454f !important;
}
.btn-switch-on {
  color: white;
  background-color: #FF8030; /* Warna latar belakang tipis saat hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Bayangan saat dihover */
}
.mobile-drawer :deep(.v-navigation-drawer__content) {
  /* keep content scrollable on mobile */
  overflow-y: auto;
}

.mobile-drawer {
  z-index: 10000 !important;
}

.mobile-drawer :deep(.v-overlay__scrim) {
  z-index: 9999 !important;
}

</style>